import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=1c005f42&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=1c005f42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c005f42",
  null
  
)

export default component.exports